import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Store } from '@ngxs/store';
import { v4 as uuidv4 } from 'uuid';
import { PdEvent } from '../../dtos/pd.dto';
import { getIdsFromDefaultItemsForSelect } from '../../helpers/select.utilities';
import { PdEventSearchService } from '../../services/pd/pd-event-search.service';

@Component({
  selector: 'app-pd-event-select',
  templateUrl: './pd-event-select.component.html',
  styleUrl: './pd-event-select.component.scss',
  standalone: false,
})
export class PdEventSelectComponent implements OnInit {
  eventList: PdEvent[];

  eventLibrary: PdEvent[] = [];

  searchLoading = false;

  labelId = uuidv4();

  internalSelectedEvent: PdEvent | null = null;

  internalSelectedEventList: PdEvent[] = [];

  @ViewChild('select') select: NgSelectComponent;

  @Input() simpleSelect = false;

  @Input() clearAfterSelection = false;

  @Input() label = 'Search for and select an Event';

  @Input() placeholder = 'Search for an event...';

  @Input() isMulti = false;

  @Input() defaultEvents: number | number[] | PdEvent[] | null;

  @Output() readonly selectedEventList: EventEmitter<PdEvent[]> =
    new EventEmitter();

  @Output() readonly selectedEvent: EventEmitter<PdEvent | null> =
    new EventEmitter();

  constructor(
    private pdEventSearch: PdEventSearchService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.loadEvents();
  }

  loadEvents(outputAfter = false) {
    this.searchLoading = true;

    this.pdEventSearch.getAllEvents().subscribe((events) => {
      this.addEvents(events, outputAfter);
    });
  }

  addEvents(events: PdEvent[], outputAfter = false) {
    this.eventLibrary = [...this.eventLibrary, ...events];
    this.eventList = events;
    this.eventList.sort((a, b) => {
      const aText = a.title.toLowerCase();
      const bText = b.title.toLowerCase();
      if (aText > bText) {
        return 1;
      }
      if (bText > aText) {
        return -1;
      }
      return 0;
    });

    this.searchLoading = false;
    if (this.defaultEvents) {
      const eventIds = getIdsFromDefaultItemsForSelect(this.defaultEvents);
      if (this.isMulti && this.defaultEvents) {
        eventIds.forEach((schoolId) => {
          const selectedEvent = this.eventLibrary.find(
            (school) => school.id === schoolId
          ) as PdEvent;
          if (
            selectedEvent &&
            !this.internalSelectedEventList.includes(selectedEvent)
          ) {
            this.internalSelectedEventList.push(selectedEvent);
          }
        });
      } else {
        const selectedEvent = this.eventLibrary.find(
          (event) => event.id === eventIds[0]
        );
        if (selectedEvent) {
          this.internalSelectedEvent = selectedEvent;
        }
      }
    }
    if (outputAfter) {
      this.outputEvents();
    }
  }

  reset() {
    if (this.isMulti) {
      this.internalSelectedEventList = [];
    } else {
      this.internalSelectedEvent = null;
    }
    this.select.selectedItems.forEach((item) => {
      this.select.unselect(item);
    });
  }

  eventSelected(school: PdEvent) {
    if (this.isMulti && school) {
      if (!this.internalSelectedEventList.includes(school)) {
        this.internalSelectedEventList.push(school);
      }
      this.select.handleClearClick();
    } else {
      this.internalSelectedEvent = school;
    }
    this.outputEvents();
    if (this.clearAfterSelection) {
      setTimeout(() => {
        this.select.unselect(this.select.selectedItems[0]);
      });
    }
  }

  outputEvents() {
    if (this.isMulti) {
      this.selectedEventList.emit(this.internalSelectedEventList);
    } else {
      this.selectedEvent.emit(this.internalSelectedEvent);
    }
  }

  removeEventFromList(event: PdEvent) {
    this.internalSelectedEventList = this.internalSelectedEventList.filter(
      (s) => s.id !== event.id
    );
    this.eventList.push(event);
    this.eventList.sort();
    this.outputEvents();
  }
}
